import { h } from '@debbie/cortex/dist/index.js';
import { useIntegration, useIntegrationActivation, } from '@debbie/cortex/dist/integrations/index.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { load } from '../connect/utils.js';
import Errors from '../Errors.js';
const IntegrationPreview = (props) => {
    const activation = useIntegrationActivation(props.id);
    const integration = useIntegration(h.hasData(activation) ? activation.data.integrationId : undefined);
    return (React.createElement("div", null,
        h.isError(activation) ? (React.createElement(Errors, { errors: [activation.error.message] })) : null,
        load({ activation, integration }, ({ activation, integration }) => {
            return (React.createElement(Link, { to: `/creditors/${activation.creditorId}/integrations/${activation.integrationId}` }, integration.name));
        }, 'loading')));
};
export default IntegrationPreview;
//# sourceMappingURL=IntegrationPreview.js.map